import FlightOutlinedIcon from '@mui/icons-material/FlightOutlined'
import HelpOutlineSharpIcon from '@mui/icons-material/HelpOutlineSharp'
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined'
import WorkHistoryOutlinedIcon from '@mui/icons-material/WorkHistoryOutlined'
import { Divider } from '@mui/material'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid'
import Skeleton from '@mui/material/Skeleton'
import Typography from '@mui/material/Typography'
import { CustomThemeContext } from 'common/providers/CustomThemeProvider'
import { setDatosVacaciones } from 'features/solicitudes/solicitudesSlice'
import { useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import useFetchWidget from '../hooks/useFetchWidget'

const WidgetsCalendario = ({
  currentYear = new Date().getFullYear(),
  useUser = [null, () => {}],
  display = 'D', // D: Dias, H: Horas
  sx = {},
  requestCode = null,
  requestOrigin = null,
}) => {
  const { themeController } = useContext(CustomThemeContext)

  const dispatch = useDispatch()

  const [user, _] = useUser
  const [widgets, setWidgets] = useState(null)
  const [visulization, setVisulization] = useState(display)
  const { response, loading } = useFetchWidget({
    year: currentYear,
    user,
    requestCode,
    requestOrigin,
  })

  useEffect(() => {
    if (response) {
      setWidgets(response)
      dispatch(
        setDatosVacaciones({
          pendientes: response.pendientes,
          tipo_dias: response.tipo_dias,
          disfruta_horas: response.disfruta_horas,
        }),
      )
    }
  }, [response])

  useEffect(() => {
    setVisulization(display)
  }, [display])

  const box = {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  }
  const icono = {
    position: 'absolute',
    top: '-50px',
    left: '-50px',
    height: '120px',
    width: '120px',
    opacity: '0.2',
  }
  const card = {
    padding: '0 10px',
    backgroundColor: 'paper.dark',
    '&:hover': {
      backgroundColor: 'paper.main',
      opacity: [0.9, 0.8, 0.7],
    },
    height: '100%',
  }
  const cardRojo = {
    backgroundColor: 'error.dark',
    color: 'error.contrastText',
    '&:hover': {
      backgroundColor: 'error.main',
      opacity: [0.9, 0.8, 0.7],
    },
    height: '100%',
  }
  const cardVerde = {
    backgroundColor: 'success.dark',
    color: 'success.contrastText',
    '&:hover': {
      backgroundColor: 'success.main',
      opacity: [0.9, 0.8, 0.7],
    },
    height: '100%',
  }

  return (
    <Box sx={{ ...sx }}>
      {loading ? (
        <Grid container spacing={2}>
          <Grid item size={{ xs: 3 }}>
            <Skeleton variant="rectangular" height={106} />
          </Grid>
          <Grid item size={{ xs: 3 }}>
            <Skeleton variant="rectangular" height={106} />
          </Grid>
          <Grid item size={{ xs: 3 }}>
            <Skeleton variant="rectangular" height={106} />
          </Grid>
          <Grid item size={{ xs: 3 }}>
            <Skeleton variant="rectangular" height={106} />
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={2}>
          {widgets?.solicitud_vacaciones_activa ? (
            <Grid item size={{ xs: 6, md: themeController.hide?.Calendar?.Disfrutadas ? 6 : 3 }}>
              <Card sx={card}>
                <CardContent>
                  <Box sx={box}>
                    <HelpOutlineSharpIcon sx={icono} />
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        alignItems: 'center',
                        gap: 1,
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                        <Typography variant="h4">{`${widgets?.solicitadas}`}</Typography>
                        {widgets?.horas_solicitadas && widgets?.horas_solicitadas > 0 ? (
                          <Typography variant="body1">días</Typography>
                        ) : (
                          <></>
                        )}
                      </Box>
                      {widgets?.horas_solicitadas && widgets?.horas_solicitadas > 0 ? (
                        <>
                          <Divider orientation="vertical" sx={{ height: '32px' }}>
                            y
                          </Divider>
                          <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                            <Typography variant="h4">{`${widgets?.horas_solicitadas}`}</Typography>
                            <Typography variant="body1">horas</Typography>
                          </Box>
                        </>
                      ) : (
                        <></>
                      )}
                    </Box>
                    <Typography variant="body1">Solicitadas</Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ) : (
            <></>
          )}
          {widgets?.solicitud_vacaciones_activa ? (
            <Grid item size={{ xs: 6, md: themeController.hide?.Calendar?.Disfrutadas ? 6 : 3 }}>
              <Card sx={cardVerde}>
                <CardContent sx={{ height: '100%' }}>
                  <Box sx={box}>
                    <ThumbUpOutlinedIcon sx={icono} />
                    <Typography variant="h4">
                      {visulization === 'D' ? widgets?.autorizadas : widgets?.horas_autorizadas}
                    </Typography>
                    <Typography variant="body1">Autorizadas</Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ) : (
            <></>
          )}
          {themeController.hide?.Calendar?.Disfrutadas ? (
            <></>
          ) : (
            <Grid item size={{ xs: 6, md: widgets?.solicitud_vacaciones_activa ? 3 : 6 }}>
              <Card sx={card}>
                <CardContent>
                  <Box sx={box}>
                    <FlightOutlinedIcon sx={icono} />
                    <Typography variant="h4">
                      {visulization === 'D' ? widgets?.disfrutados : widgets?.horas_disfrutados}
                    </Typography>
                    <Typography variant="body1">Disfrutadas</Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          )}
          {themeController.hide?.Calendar?.Pendientes ? (
            <></>
          ) : (
            <Grid item size={{ xs: 6, md: widgets?.solicitud_vacaciones_activa ? 3 : 6 }}>
              <Card sx={cardRojo}>
                <CardContent>
                  <Box sx={box}>
                    <WorkHistoryOutlinedIcon sx={icono} />
                    <Typography variant="h4">
                      {visulization === 'D' ? widgets?.pendientes : widgets?.horas_pendientes}
                    </Typography>
                    <Typography variant="body1">Pendientes</Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          )}
        </Grid>
      )}
    </Box>
  )
}

export default WidgetsCalendario
